import { RobotTextResources } from "@portal/assets/text/RobotTextResources";

export const PlanningPageData = (isDefaultLanguage: boolean) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const yearOne = texts.PAGE_4_DATA_ONE;
  const yearFive = texts.PAGE_4_DATA_FIVE;
  const yearTen = texts.PAGE_4_DATA_TEN;

  return {
    title: {
      text: texts.PAGE_4_CHART_HISTORIC,
      style: { color: "#02304b", fontSize: 12 },
    },
    credits: { enabled: false },
    accessibility: { enabled: false },
    chart: { type: "column" },
    xAxis: { type: "category" },
    yAxis: { title: null, labels: { enabled: false } },
    plotOptions: { column: { grouping: false, stacking: "normal", dataLabels: { enabled: true, format: "{y} %" } } },
    tooltip: {
      headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
      pointFormat: '<span style="color:{point.color}">{point.name}</span> {point.y:.2f}%',
    },
    series: [
      {
        name: texts.PAGE_4_CHART_BEST_PERIOD,
        color: "#e0a507",
        data: [
          { name: yearOne, y: 45, x: 0 },
          { name: yearFive, y: 24, x: 1 },
          { name: yearTen, y: 13, x: 2 },
        ],
      },
      {
        name: texts.PAGE_4_CHART_WORST_PERIOD,
        color: "#02304b",
        data: [
          { name: yearOne, y: -42, x: 0 },
          { name: yearFive, y: -6, x: 1 },
          { name: yearTen, y: -3, x: 2 },
        ],
      },
    ],
    legend: { enabled: false },
  };
};
